export const LOCAL_STORAGE_GA = '@parkdepot/ga_consent'

export const LOCAL_STORAGE_set_ga = (consent: boolean) => {
    localStorage.setItem(LOCAL_STORAGE_GA, JSON.stringify(consent))
}

export const LOCAL_STORAGE_get_ga = (): string => {
    const consent = localStorage.getItem(LOCAL_STORAGE_GA)
    return consent ? JSON.parse(consent) : ''
}
